import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import { breadcrumb, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';
import { buildJsonLd, itemDataset } from 'rise-ui/utils/data.js';

@scrollRoot
export default class CatalogRecordItemRoute extends Route {
  @service dataset;
  @service keywords;
  @service store;

  setHeadTags(model) {
    const record = model?.record;
    if (!record) {
      return;
    }
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: model.item.description,
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            false,
            record.themes,
            record.tags,
          ),
        },
      },
      {
        type: 'script',
        attrs: {
          type: 'application/ld+json',
        },
        content: buildJsonLd(itemDataset(model.item, this.dataset.urlFn)),
      },
    ];
  }

  @breadcrumb crumb = 'Catalog Record Item';

  async model({ item_id }) {
    const { record } = await this.modelFor('catalog.record');
    let itemModel;
    const otherItemsForCatalogRecord = [];
    for (const item of await record.items) {
      if (item.id === item_id) {
        itemModel = item;
      } else {
        otherItemsForCatalogRecord.push(item);
      }
    }
    return {
      record,
      location: await record.location,
      item: itemModel,
      otherItemsForCatalogRecord,
    };
  }

  afterModel(model) {
    if (!model.item) {
      throw 'not-found';
    }
    this.setHeadTags(model);
  }

  @breadcrumbResolved modelCrumb(model) {
    return model.item.get('title');
  }
}
